export default Object.freeze({
  Continue: 1,
  ThrowError: 2,
});
